import sizeof from 'object-sizeof'
import bytesToSize from '@helpers/bytesToSize'
import setObjectPath from "@helpers/setObjectPath.helper";
import metadata from '@store/modules/shared/metadata.modules'
import imageCrop from '@store/modules/designIframe/imageCrop.modules'
import component from '@store/modules/designIframe/component.modules'
import texteditor from '@store/modules/designIframe/texteditor.modules'
import frame from '@store/modules/designIframe/frame.modules'
import frameTool from '@store/modules/designIframe/frameTool.modules'
import modals from '@store/modules/designIframe/modals.modules'
import snapshot from '@store/modules/designIframe/snapshot.modules'
import page from '@store/modules/designIframe/page.modules'
import original from '@store/modules/design/original.modules'
import permissionWebsite from '@store/modules/shared/permissionWebsite.modules'
import siteData from '@store/modules/shared/siteData.modules'
import userPreference from '@store/modules/designIframe/userPreference.modules'
import windowEvent from '@store/modules/designIframe/windowEvent.modules'
import ai from '@store/modules/designIframe/ai.modules'
import credit from '@store/modules/designIframe/credit.modules'
const state = {
    iframeScale: 1,
    preview: undefined,
    mode: undefined,
    allowParent: process.env.VUE_APP_ALLOW_PARENT_POST_MSG,
    toggleHeaderSidenavMenu: false,
    headerIsSticky: false,
    adsMWE : true,
    openFilterProductMobile: false,
    // googleMap: undefined,
};

const getters = {
    mode: state => {
        return state.mode
    },
    iframeScale: state => {
        return state.iframeScale
    },
    preview: state => {
        return state.preview
    },
    toggleHeaderSidenavMenu: (state) => {
        return state.toggleHeaderSidenavMenu;
    },
    headerIsSticky: (state) => {
        return state.headerIsSticky;
    },
    adsMWE: state => {
        return state.adsMWE;
    },
    openFilterProductMobile: state => {
        return state.openFilterProductMobile;
    }
    // googleMap: (state) => {
    //     return state.googleMap;
    //   },
};

const actions = {
    init({ dispatch }, { iframeScale }) {
        dispatch('setIframeScale', { iframeScale: iframeScale });
    },

    setMode({ commit }, { mode }) {
        commit('SET_MODE', { mode })
    },
    setIframeScale({ commit }, { iframeScale }) {
        commit('SET_IFRAME_SCALE', { iframeScale: iframeScale })
    },
    postToParent(_, { func, payload, root = false }) {
        window.parent.postMessage(
            {
                func,
                root,
                payload,
                timestamp: new Date().getTime()
            },
            state.allowParent
        );
    },
    listentParent({ dispatch }) {
        window.onmessage = (e) => dispatch("parentMsg", e)
    },
    callFromParent(_, { txt }) {
        console.log({ txt });
    },
    parentMsg({ dispatch }, event) {
        if (event.origin !== state.allowParent) return;

        var { func, payload, timestamp, root } = event.data;
        if (func) {
            const delay = new Date().getTime() - timestamp
            if (sizeof(payload) > 100) {
                console.log(`>>> "${func}" payload size ${bytesToSize(sizeof(payload))}, delay ${delay}ms`, payload);
            }
            dispatch(func, payload, { root })
        }
    },
    setToggleHeaderSidenavMenu({ commit }, value) {
        commit('SET_TOGGLE_HEADER_SIDENAV_MENU', { value: value })
    },
    // setGoogleMap({ commit }, gmap) {

    //     commit('SET_GOOGLEMAP', gmap);
    // },

    setScreenSize({ dispatch }, { size }) {
        dispatch("setScreenSize", { size: size }, { root: true })
    },
    setHeaderIsSticky({ commit }, value ) {
        commit("SET_HEADER_IS_STICKY", { value: value })
    },
    setAdsMWE({ commit }, {adsMWE} ) {
        commit("SET_ADS_MWE", { value: adsMWE })
    },
    setOpenFilterProductMobile({ commit }, value) {
        commit('SET_OPEN_FILTER_PRODUCT_MOBILE', value)
    },
};

const mutations = {

    SET_MODE(state, { mode }) {
        state.mode = mode
    },
    SET_IFRAME_SCALE(state, { iframeScale }) {
        state.iframeScale = iframeScale;
    },
    SET_PREVIEW(state, { preview }) {
        state.preview = preview
    },
    setStatePath(state, { value, path }) {
        setObjectPath(state, value, path)
        state = { ...state }
    },
    SET_TOGGLE_HEADER_SIDENAV_MENU(state, { value }) {
        state.toggleHeaderSidenavMenu = value;
    },
    SET_HEADER_IS_STICKY(state, { value }) {
        state.headerIsSticky = value
    },
    SET_ADS_MWE(state, { value }) {
        state.adsMWE = value
    },
    SET_OPEN_FILTER_PRODUCT_MOBILE(state, value) {
        state.openFilterProductMobile = value;
    },
    // SET_GOOGLEMAP(state, gmap) {

    //     state.googleMap = gmap;

    //   },
};

const modules = {
    userPreference,
    metadata,
    texteditor,
    component,
    frame,
    frameTool,
    modals,
    snapshot,
    page,
    original,
    windowEvent,
    imageCrop,
    permissionWebsite,
    siteData,
    ai,
    credit,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules
};
